export const getAppendedClassWithDevice = (baseClass: string, isMobile: boolean = false): string =>
    `${baseClass} ${isMobile ? 'mobile' : 'desktop'}`;